const mutations = {
  /**
   * Set the creditsPercentageUse property on state
   * with creditsPercentageUse.
   *
   * @param state
   * @param creditsPercentageUse
   */
  setCreditsPercentageUse(state, creditsPercentageUse) {
    state.creditsPercentageUse = creditsPercentageUse;
  },

  /**
   * Set the creditsUseLast30Days property on state
   * with creditsUseLast30Days.
   *
   * @param state
   * @param creditsUseLast30Days
   */
  setCreditsUseLast30Days(state, creditsUseLast30Days) {
    state.creditsUseLast30Days = creditsUseLast30Days;
  },

  /**
   * Set the creditsUseToday property on state
   * with creditsUseToday.
   *
   * @param state
   * @param creditsUseToday
   */
  setCreditsUseToday(state, creditsUseToday) {
    state.creditsUseToday = creditsUseToday;
  },

  /**
   * Set the creditsUseLast30DaysChart.series property on state
   * with creditsUseLast30DaysChartSeries.
   *
   * @param state
   * @param creditsUseLast30DaysChartSeries
   */
  setCreditsUseLast30DaysChartSeries(state, creditsUseLast30DaysChartSeries) {
    state.creditsUseLast30DaysChart.series = creditsUseLast30DaysChartSeries;
  },

  /**
   * Set the creditsUseLast30DaysChart.xAxis property on state
   * with creditsUseLast30DaysChartXAxis.
   *
   * @param state
   * @param creditsUseLast30DaysChartXAxis
   */
  setCreditsUseLast30DaysChartXAxis(state, creditsUseLast30DaysChartXAxis) {
    state.creditsUseLast30DaysChart.xAxis = creditsUseLast30DaysChartXAxis;
  },
};

export default mutations;
